"use strict";var w10NOOP = require("warp10/constants").NOOP;
exports.aL_ = w10NOOP;
exports.W_ = function () {
  return w10NOOP;
};